import { render } from "./VehicleEditing.vue?vue&type=template&id=fd66d07a&ts=true"
import script from "./VehicleEditing.vue?vue&type=script&lang=ts"
export * from "./VehicleEditing.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/lmd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__